/**
 * Created by wang chong on 2017/12/29.
 */
import maple from 'maple';
import domain from '../domain';
var tgLocalStorage = {};
if (!window.localStorage) {
    tgLocalStorage = {
        getItem: function (sKey) {
            if (!sKey || !this.hasOwnProperty(sKey)) { return null; }
            return unescape(document.cookie.replace(new RegExp("(?:^|.*;\\s*)" + escape(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*"), "$1"));
        },
        key: function (nKeyId) {
            return unescape(document.cookie.replace(/\s*\=(?:.(?!;))*$/, "").split(/\s*\=(?:[^;](?!;))*[^;]?;\s*/)[nKeyId]);
        },
        setItem: function (sKey, sValue) {
            if(!sKey) { return; }
            document.cookie = escape(sKey) + "=" + escape(sValue) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/";
            this.length = document.cookie.match(/\=/g).length;
        },
        length: 0,
        removeItem: function (sKey) {
            if (!sKey || !this.hasOwnProperty(sKey)) { return; }
            document.cookie = escape(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
            this.length--;
        },
        hasOwnProperty: function (sKey) {
            return (new RegExp("(?:^|;\\s*)" + escape(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
        }
    };
    tgLocalStorage.length = (document.cookie.match(/\=/g) || tgLocalStorage).length;
}else{
    tgLocalStorage = window.localStorage;
}

class NodeLog {
    constructor(){
        this.isWeixin = maple.device('weixin');
        //TODO 暂时全部发送到线上库中
        if(domain.env === 'online' || true){
            this.domain = "//nodelog.51tiangou.com";
        }else{
            this.domain = "//nodelog." + domain.env + ".66buy.com.cn";
        }
    }

    /**
     * 通用请求接口
     * @param path
     * @param params
     * @returns {boolean}
     * @private
     */
    _commonReq(path, params = {}){
        let searchList = [];
        if(typeof path === 'undefined'){
            return false;
        }

        //追加try catch操作，避免页面崩溃
        try {
            for(let key in params){
                if(params.hasOwnProperty(key)){
                    searchList.push(`${key}=${params[key]}`);
                }
            }
            searchList.push(`t=${Date.now()}`); //追加随机参数，避免浏览器缓存该图片

            let hm = document.createElement("img");
            let s = document.getElementsByTagName("body")[0];
            hm.src = `${this.domain}${path}?${searchList.join('&')}`;
            hm.style.display = "none";
            s.parentNode.insertBefore(hm, s);
            return true;
        } catch (e){
            return false;
        }
    }

    /**
     * 通用标签日志追加
     *  使用方法：
     *      Step1： 在http://nodelog.51tiangou.com/#/label 上新建标签(tagName)
     *      Step2： 调用nodeLog.tag()方法
     *      Step3： 在http://nodelog.51tiangou.com/#/label 上点击建立的标签读取查看数据
     * @param tagName   Step1中建立的标签名称
     * @param message   想传递的消息值
     * @returns {*}
     */
    tag(tagName, message = ''){
        if(typeof tagName === 'undefined'){
            return false;
        }
        return this._commonReq('/log/custom/add', {key:tagName, message});
    }

    /**
     * 客户端openId占比的记录（仅微信端）
     * @param hasOpenId
     */
    openIdLog(hasOpenId = true){
        const OPEN_ID_KEY = 'hasOpenId',
            uuid = maple.cookie('tgs_uuid'),
            uniqueIndex = `${uuid}_${OPEN_ID_KEY}`;

        //只在微信环境下记录这条log，并且每个用户只发送一次
        this.isWeixin && !tgLocalStorage.getItem(uniqueIndex) && this.tag(OPEN_ID_KEY, hasOpenId) && tgLocalStorage.setItem(uniqueIndex, true) ;
    }

    /**
     * 微信端续登录失败情况的记录
     * @param msg
     */
    wcAutoLoginFailLog(msg = 'api_tg_error'){
        const TAG_NAME = 'wcAutoLoginFail',
            uuid = maple.cookie('tgs_uuid'),
            uniqueIndex = `${uuid}_${TAG_NAME}`;

        //只在微信环境下记录这条log，并且每个会话只发送一次
        this.isWeixin && !sessionStorage.getItem(uniqueIndex) && this.tag(TAG_NAME, msg) && sessionStorage.setItem(uniqueIndex, true) ;
    }
}
export default new NodeLog();